"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_virtualized_1 = require("react-virtualized");
require("react-virtualized/styles.css");
var Select_1 = __importDefault(require("../Select"));
var VirtualRowRenderer_1 = __importDefault(require("./VirtualRowRenderer"));
var ROW_HEIGHT = 48;
var DEFAULT_LIST_WIDTH = 250;
var DEFAULT_LIST_HEIGHT = 250;
var valueRenderer = function (items) {
    if (items === void 0) { items = []; }
    return function (selected) {
        var _a = (items
            .find(function (item) { return item.key === selected; }) || {}).value, value = _a === void 0 ? '' : _a;
        return value;
    };
};
var List = react_virtualized_1.List;
var Select = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? { select: {}, formControl: {} } : _b, _c = _a.autoWidth, autoWidth = _c === void 0 ? false : _c, defaultValue = _a.defaultValue, _d = _a.displayEmpty, displayEmpty = _d === void 0 ? false : _d, IconComponent = _a.IconComponent, id = _a.id, inputProps = _a.inputProps, _e = _a.label, label = _e === void 0 ? null : _e, labelId = _a.labelId, _f = _a.labelWidth, labelWidth = _f === void 0 ? 0 : _f, MenuProps = _a.MenuProps, _g = _a.native, native = _g === void 0 ? false : _g, onChange = _a.onChange, SelectDisplayProps = _a.SelectDisplayProps, value = _a.value, _h = _a.variant, variant = _h === void 0 ? 'standard' : _h, fullWidth = _a.fullWidth, _j = _a.helperText, helperText = _j === void 0 ? '' : _j, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, placeholder = _a.placeholder, field = _a.field, _k = _a.items, items = _k === void 0 ? [] : _k, _l = _a.error, error = _l === void 0 ? false : _l, _m = _a.readOnly, readOnly = _m === void 0 ? false : _m, multiple = _a.multiple, _o = _a.width, width = _o === void 0 ? DEFAULT_LIST_WIDTH : _o, _p = _a.height, height = _p === void 0 ? DEFAULT_LIST_HEIGHT : _p;
    var _q = (0, react_1.useState)(false), isOpen = _q[0], setIsOpen = _q[1];
    var onOpen = (0, react_1.useCallback)(function () { return setIsOpen(true); }, [setIsOpen]);
    var onClose = (0, react_1.useCallback)(function () { return setIsOpen(false); }, [setIsOpen]);
    var onChangeHandler = (0, react_1.useCallback)(function (event, child) {
        if (onChange)
            onChange(event, child);
        setIsOpen(false);
    }, [setIsOpen, onChange]);
    var rowRenderer = (0, react_1.useMemo)(function () { return (0, VirtualRowRenderer_1.default)(items, value, onChangeHandler); }, [items, value, onChangeHandler]);
    var rowCount = (0, react_1.useMemo)(function () { return items.length; }, [items]);
    return (react_1.default.createElement(Select_1.default, { classes: classes, open: isOpen, onOpen: onOpen, onClose: onClose, onChange: onChangeHandler, autoWidth: autoWidth, defaultValue: defaultValue, displayEmpty: displayEmpty, IconComponent: IconComponent, id: id, inputProps: inputProps, label: label, labelId: labelId, labelWidth: labelWidth, MenuProps: MenuProps, native: native, SelectDisplayProps: SelectDisplayProps, value: value, variant: variant, fullWidth: fullWidth, error: error, readOnly: readOnly, field: field, helperText: helperText, placeholder: placeholder, renderValue: valueRenderer(items), multiple: multiple, startAdornment: startAdornment, endAdornment: endAdornment },
        react_1.default.createElement(List, { height: height, rowCount: rowCount, rowHeight: ROW_HEIGHT, rowRenderer: rowRenderer, width: width })));
};
exports.default = react_1.default.memo(Select);
